import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form'];
  static classes = ['errorm','hide'];
  static values = {validateurl: String};

  formTargetConnected() {
    this.control_show_and_hide();
    super.connect();
  }

  copy_address(e){
    console.log(e)
    if(e.target.checked){
      this.formTarget.querySelector("#user_prescription_invoice_post_code").value = this.formTarget.querySelector("#user_prescription_send_post_code").value
      this.formTarget.querySelector("#user_prescription_invoice_prefecture").value = this.formTarget.querySelector("#user_prescription_send_prefecture").value
      this.formTarget.querySelector("#user_prescription_invoice_city").value = this.formTarget.querySelector("#user_prescription_send_city").value
      this.formTarget.querySelector("#user_prescription_invoice_address").value = this.formTarget.querySelector("#user_prescription_send_address").value
    }
  }

  control_show_and_hide(){
    const delivery_to_shop = this.formTarget.querySelector("#user_prescription_delivery_to_shop")
    const pharmacy_information = this.formTarget.querySelector('#pharmacy_information_input_field')
    const medication_guidance = this.formTarget.querySelector('#medication_guidance_input_field')
    const send_address = this.formTarget.querySelector("#send_address_field");
    // const invoice_address = this.formTarget.querySelector("#invoice_address_field");

    if(delivery_to_shop.checked){
      pharmacy_information.hidden = false;
      medication_guidance.hidden = true;
      //send_address.hidden = true;
      // invoice_address.hidden = true;
    } else {
      pharmacy_information.hidden = true;
      medication_guidance.hidden = false;
      //send_address.hidden = false;
      // invoice_address.hidden = false;

      const medication_guidance_tel = this.formTarget.querySelector('#user_prescription_medication_guidance_tel');
      const medication_consent = this.formTarget.querySelector('#medication_consent_input_field');
      const guidance_time = this.formTarget.querySelector('#guidance_time_input_field');

//      if(medication_guidance_tel != undefined && medication_guidance_tel.checked){
//        medication_consent.hidden = true;
//        guidance_time.hidden = false;
//      }else{
//        medication_consent.hidden = false;
//        guidance_time.hidden = true;
//      }
    }
  }
  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
      if(errorM == undefined){
        errorM = pa.parentElement.parentElement.querySelector("."+this.errormClass);
      }
    }
    this.control_show_and_hide()
    const formData = new FormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

  validateAll(){
    let errorMs = document.querySelectorAll("."+this.errormClass);
    errorMs.forEach(function (m) {
        m.textContent = "";
    });
    const formData = new FormData(this.formTarget);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        if(Object.keys(response).length > 0){
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
              }
            })
          });
        }else{
          this.formTarget.submit();
        }
      }
    });
  }
}
